// extracted by mini-css-extract-plugin
module.exports = {"card":"Principios_card__1ZoXJ","gallery":"Principios_gallery__IqzB6"};